<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 20 18">
    <path
      d="M10.608 12V6M7.60799 9H13.608M10.608 17.5C15.3024 17.5 19.108 13.6944 19.108 9C19.108 4.30558 15.3024 0.5 10.608 0.5C5.91357 0.5 2.10799 4.30558 2.10799 9C2.10799 9.95 2.26384 10.8636 2.55136 11.7166C2.65956 12.0376 2.71366 12.1981 2.72342 12.3214C2.73306 12.4432 2.72577 12.5286 2.69565 12.6469C2.66514 12.7668 2.59779 12.8915 2.46309 13.1408L0.827429 16.1684C0.594118 16.6002 0.477462 16.8161 0.503571 16.9828C0.526311 17.1279 0.61174 17.2557 0.737167 17.3322C0.88117 17.4201 1.12529 17.3948 1.61353 17.3444L6.73456 16.815C6.88964 16.799 6.96718 16.791 7.03785 16.7937C7.10737 16.7963 7.15644 16.8029 7.22423 16.8185C7.29315 16.8344 7.37981 16.8678 7.55315 16.9345C8.5012 17.2998 9.53121 17.5 10.608 17.5Z"
      :class="colorClass"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
